<template>
  <div class="login-by-phone">
    <el-form ref="form" :rules="rules" :model="form">
      <el-form-item prop="mail">
        <el-input
          AUTOCOMPLETE="off"
          v-model="form.mail"
          placeholder="邮箱"
          auto-complete="new-password"
        >
          <i
            slot="prefix"
            class="el-input__icon icon iconfont icon-youxiang1"
          ></i>
        </el-input>
      </el-form-item>

      <el-form-item  prop="password">
        <el-input
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
          auto-complete="new-password"
        >
          <i slot="prefix" class="el-input__icon icon iconfont icon-suo"></i>
        </el-input>
      </el-form-item>

      <el-form-item class="form-item" prop="code">
        <el-input
          v-model="form.code"
          placeholder="请输入短信验证码"
          auto-complete="new-password"
        >
          <div
            class="verification-class"
            v-if="isShow"
            @click="verification"
            slot="append"
          >
            获取验证码
          </div>
          <div v-else slot="append">{{ count }}秒后再获取</div>
          <i
            slot="prefix"
            class="el-input__icon icon iconfont icon-renzhengguanli"
          ></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="type">
        <el-checkbox-group v-model="form.type">
          <el-checkbox name="type"></el-checkbox>
          <span class="ruleurlbox"
            >同意我们的<router-link
              :to="{ name: 'rule' }"
              class="ruleurl"
              tag="a"
            >
              <span>使用条款</span>
            </router-link>
            和
            <router-link
              :to="{ name: 'privacy' }"
              class="ruleurl"
              tag="a"
              target="_blank"
              ><span>隐私政策</span></router-link
            ></span
          >
          <span class="forget-password"
            >已有账号？
            <router-link :to="{ name: 'login' }">去登录</router-link></span
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')" class="loginbutton"
          >注&nbsp;册</el-button
        >
      </el-form-item>
      <!-- <p class="register-line">
        还没有账号?<router-link :to="{ name: 'register' }"
          ><span class="register">立即注册</span>
        </router-link>
      </p> -->
    </el-form>
  </div>
</template>
  <script>
import LoginTitle from "./LoginTitle.vue";
import CountDown from "../common/CountDown.vue";
import Vcode from "vue-puzzle-vcode";

export default {
  components: {
    LoginTitle,
    CountDown,
    Vcode,
  },
  data() {

    var validatorMail = (rule, value, callback) => {
      this.showPasswordError = false;
      if (value === "") {
        callback(new Error("邮箱不能为空"));
      } else if (!/^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(value)) {
        callback(new Error("邮箱号格式错误"));
      } else {
        var info = {};
        info.mail = value;
        info.type = 2;
        this.$api.user.userExist(info).then((res) => {
          if (res.data.errno == 0) {
            this.showPasswordError = true;
            callback();            
          } else {
            callback(new Error(res.data.errmsg));
          }
        });
      }
    };
    var validatorPassword = (rule, value, callback) => {
      if (this.showPasswordError||this.allCheck) {
        if (value === "") {
          callback(new Error("密码不能为空"));
        } else if (value.length < 6 || value.length > 16) {
          callback(new Error("密码长度在 6 到 16 个字符之间"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validatorCode = (rule, value, callback) => {
      if (this.showPasswordError||this.allCheck) {
        if (value === "") {
          callback(new Error("验证码不能为空"));
        } else if (value.length!=4) {
          callback(new Error("请输入4位验证码"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      form: {
        mail: "",
        password: "",
        code:"",
        type: [],
      },
      rules: {
        mail: [
          { required: true, validator: validatorMail, trigger: ["blur"] },
        ],
        password: [
          { required: true, validator: validatorPassword, trigger: ["blur"] },
        ],
        code: [{ required: true, validator: validatorCode, trigger: ["blur"] }],
        type: [
          {
            type: "array",
            required: true,
            message: "您还没有同意协议",
            trigger: "change",
          },
        ],
      },
      isShow: true,
      count: 0,
      visShow: false,
      showPasswordError: true,
      allCheck: false,
    };
  },
  methods: {
    filedCheck(prop) {
      let noSave = false;
      this.$refs.form.validateField(prop, (valid) => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some((i) => this.filedCheck(i));
      this.allCheck = true;
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.newRegister();
           this.allCheck = false;
        } else {
          this.allCheck = false;
          return false;
        }
      });
    },
    onSuccess(msg) {
      this.visShow = false;
      //可以在此加上axios或其他代码
    },
    onClose() {
      this.visShow = false;
    },
    verification() {
      this.sendCode();
    },
    countdown() {
      this.isShow = false; //倒计时
      // this.visShow = true;
      this.count = 60; //赋值60秒
      var times = setInterval(() => {
        this.count--; //递减
        if (this.count <= 0) {
          // <=0 变成获取按钮
          this.isShow = true;
          clearInterval(times);
        }
      }, 1000); //1000毫秒后执行
    },
    //发送验证码
    sendCode() {
      let info = {};
      info.mail = this.form.mail;
      var reg_tel3 = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (!reg_tel3.test(info.mail)) {
        this.$FUnitls.showInfo("请输入正确的邮箱号", "info");
      }
      this.$api.user.sendMailCode(info).then((res) => {
        if (res.data.errno == 0) {
          this.$FUnitls.showInfo("发送成功", "info");
          this.countdown();
        } else {
          this.$FUnitls.showInfo(res.data.msg, "info");
        }
      });
    },
    tologin() {
      this.$router.push({ name: "login" });
    },

    newRegister() {
      let info = {};
      info.type = 2;
      info.mail = this.form.mail;
      info.password = this.form.password;
      info.code = this.form.code;

      this.$api.user.newRegister(info).then((res) => {
        if (res.data.errno == 0) {
          this.$FUnitls.showInfo("注册成功", "success", this.tologin);
        } else {
          this.$FUnitls.showInfo(res.data.errmsg, "error");
        }
      });
    },
  },
  mounted() {},
};
</script>
  <!--声明语言，并且添加scoped-->
  <style scoped>
.ruleurlbox {
  color: #666666;
  font-size: 14px;
  margin-left: 5px;
}
.ruleurlbox a {
  color: #0464cd;
}
.icon-shouji {
  color: #0464cd;
}
.form-item {
  position: relative;
  margin-bottom: 15px;
}
.verification-class {
  cursor: pointer;
}
.login-by-phone >>> input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #c7c6c6 inset !important;
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
  -webkit-text-fill-color: #666 !important;
}

.login-by-phone >>> .el-input--prefix .el-input__inner {
  color: #666 !important;
  font-size: 16px;
  padding-left: 50px;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  height: 54px;
  line-height: 54px;
  border-radius: 0;
}
.login-by-phone >>> .el-input--prefix .el-input__inner:-webkit-autofill {
  color: #666 !important;
}

.register-line {
  text-align: center;
  font-size: 16px;
  color: #666;
}
.register-line .register {
  color: #0464cd;
}

.login-by-phone >>> .el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus {
  border: none;
  border-bottom: 1px solid #e6e6e6;
}

.login-by-phone >>> .el-input--prefix .iconfont.icon-youxiang1 {
  font-size: 26px;
}
.login-by-phone >>> .el-input-group__append,
.login-by-phone >>> .el-input-group__prepend {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #0464cd;
}
.login-by-phone >>> .el-input__prefix .iconfont.icon-renzhengguanli {
  font-size: 26px;
}
.login-by-phone >>> .el-input__prefix .iconfont.icon-suo {
  font-size: 26px;
}
.login-by-phone >>> .el-input__prefix {
  padding-top: 2px;
}
.login-by-phone >>> .el-input__prefix .iconfont {
  color: #0464cd;
  font-size: 20px;
}
.login-by-phone >>> .loginbutton {
  width: 100%;
  font-size: 20px;
}
.login-by-phone >>> .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.login-by-phone >>> .el-button {
  border-radius: 26px;
}
.forget-password {
  float: right;
  font-size: 14px;
}
.forget-password a {
  color: #0177f0;
}
.login-by-phone >>> .el-checkbox__inner {
  border-radius: 7px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/user/UserRegisterByMail.vue